module.exports = __webpack_public_path__ + "img/logo-bradescard-horizontal.97be2a7e.png";